import React, { memo } from "react";
import { getFlagIcon } from "../../../services/countryService";

/**
 * Componente para mostrar los datos del cliente durante una llamada entrante.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.customer - Objeto con los datos del cliente.
 * @param {string} props.phone - Número de teléfono del cliente.
 *
 * @returns {JSX.Element} Componente que muestra los datos del cliente.
 */
const CallCustomerData = memo(({ customer, phone }) => (
  <div className="!tw-bg-blue-800 !tw-p-2 tw-rounded-md tw-border-transparent tw-mt-2">
    {customer?.full_names && <div className="tw-text-default tw-font-normal tw-text-blue-50">{customer.full_names}</div>}
    {!customer?.full_names && (
      <div className="tw-text-default tw-font-normal tw-text-blue-50">
        {`${customer?.last_name || ''} ${customer?.first_name || ''}`.trim()}
      </div>
    )}
    {customer?.email && <div className="tw-text-xs tw-text-blue-200">{customer.email}</div>}
    {getFlagIcon(customer?.country_id, 'tw-mr-1')}
    <span className="tw-text-xs tw-text-blue-200">{phone}</span>
  </div>
));

CallCustomerData.displayName = "CallCustomerData";

export default CallCustomerData;
